import { Backdrop, Button, Card, CardActions, CardContent, Dialog, Typography, makeStyles, withStyles } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { csAdjustVerticalZoomWithRouteSelector } from "../../store/CsAdjustVerticalZoomWithRouteState";
import { csGradationState } from "../../store/CsSettingState";
import { csTargetSelectState, csTargetState } from "../../store/CopilotState";
import { useCrossSectionData } from "../../store/CrossSectionDataState";
import { useLayoutState } from "../../store/LayoutState";
import { coPiListDataStateById } from "../../store/CopilotListState";
import { useLinkableSourceList } from "../../store/AircraftSettingState";

const useStyles = makeStyles({
  selectCsSource: {
    backgroundColor: '#5A5A5A',
    color: '#FFFFFF'
  },
  lowercaseButton: {
    textTransform: 'none'
  }
});

const CustomDialog = withStyles({
  'paper': {
    backgroundColor: '#FF0000'
  }
})(Dialog);

function SelectCsSourceDialog() {
  const {t} = useTranslation();
  const classes = useStyles();
  const setCsAdjustVerticalZoomWithRoute = useSetRecoilState(csAdjustVerticalZoomWithRouteSelector);
  const setCsGradation = useSetRecoilState(csGradationState);
  const setCsTargetState = useSetRecoilState(csTargetState);
  const {setCsTypeCoPilot} = useCrossSectionData();
  const { changeHorizontal, isMapOnly } = useLayoutState();
  const [csTargetSelect, setCstargetSelect] = useRecoilState(csTargetSelectState);
  const data = useRecoilValue(coPiListDataStateById(csTargetSelect));
  const {linkableSourceList} = useLinkableSourceList();

  const handleClose = () => {
    handleSelectSource();
  }

  const handleClick = e => {
    handleSelectSource(e.currentTarget.name);
  }

  const handleSelectSource = (source) => {
    setCstargetSelect('');
    if (!source) return;
    setCsAdjustVerticalZoomWithRoute(prev => {
      return {...prev, ...{adjust: true, update: false}};
    });
    setCsGradation(true);
    setCsTargetState({id: data.aircraft_code, dataSourceId: source, someSources: true});
    setCsTypeCoPilot(data.aircraft_code, data.aircraft_name);
    if (isMapOnly) {
      changeHorizontal();
    }
  }

  return (
    <CustomDialog open={true} BackdropComponent={Backdrop} onClose={handleClose}>
      <Card className={classes.selectCsSource}>
        <CardContent>
          <Typography>
            {t('select a cross section source')}
          </Typography>
        </CardContent>
        {
          data?.sources?.map(s => {
            return <CardActions key={s.data_source_id}>
              <Button className={classes.lowercaseButton} variant="contained" onClick={handleClick} name={s.data_source_id}>
                {linkableSourceList.find(l => l.data_source_id === s.data_source_id)?.data_source_name}
              </Button>
            </CardActions>
          })
        }
      </Card>
    </CustomDialog>
  )
}

export default SelectCsSourceDialog;
